module.exports = __webpack_public_path__ + "static/media/contrato.ebb2ceaa.svg";